import { useEffect, useState } from 'react';

export const useLoading = (isLoading: boolean) => {
  const [isWaiting, setWaiting] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => setWaiting(false), 500);

    return () => clearTimeout(timer);
  }, []);

  return isLoading || isWaiting;
};
